import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './BlogDetail.css';

class BlogDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copiedLink: false,
      commentName: '',
      commentEmail: '',
      commentMessage: '',
      isCommentSubmitted: false,
      comments: [
        {
          id: 1,
          name: 'David Miller',
          avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=200',
          date: 'Aug 2, 2026 at 10:15 AM',
          text: 'This guide came at the perfect time! I am planning a trip to Bali in September and just booked one of the Ubud jungle villas mentioned here via Bookly. Can not wait!'
        },
        {
          id: 2,
          name: 'Claire Beauchamp',
          avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200',
          date: 'Aug 2, 2026 at 2:40 PM',
          text: 'The advice regarding scooters versus private drivers in Uluwatu is spot on. Thanks Sophia for another fantastic write-up!'
        }
      ]
    };
  }

  handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    this.setState({ copiedLink: true });
    setTimeout(() => this.setState({ copiedLink: false }), 3000);
  };

  handleCommentSubmit = (e) => {
    e.preventDefault();
    const { commentName, commentEmail, commentMessage, comments } = this.state;

    if (!commentName || !commentEmail || !commentMessage) return;

    const newComment = {
      id: comments.length + 1,
      name: commentName,
      avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&q=80&w=200',
      date: 'Just now',
      text: commentMessage
    };

    this.setState({
      comments: [newComment, ...comments],
      commentName: '',
      commentEmail: '',
      commentMessage: '',
      isCommentSubmitted: true
    });

    setTimeout(() => this.setState({ isCommentSubmitted: false }), 4000);
  };

  render() {
    const { copiedLink, commentName, commentEmail, commentMessage, isCommentSubmitted, comments } = this.state;

    const post = {
      title: '10 Hidden Luxury Villas in Bali You Need to Experience in 2026',
      category: 'Luxury Stays',
      date: 'August 1, 2026',
      readTime: '6 min read',
      author: {
        name: 'Sophia Reynolds',
        role: 'Senior Travel Writer & Hotel Critic',
        avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200',
        bio: 'Sophia has spent over a decade reviewing luxury resorts and boutique stays across Southeast Asia and Europe. Her work appears regularly in top travel publications.'
      },
      heroImage: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&q=80&w=1600'
    };

    const relatedPosts = [
      {
        id: 1,
        title: 'Island Hopping in Greece: Best Apartments with Sea Views',
        category: 'Destination Guides',
        image: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?auto=format&fit=crop&q=80&w=600',
        readTime: '6 min read'
      },
      {
        id: 2,
        title: 'The Ultimate Guide to Finding Boutique Hotels in Paris',
        category: 'Destination Guides',
        image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&q=80&w=600',
        readTime: '5 min read'
      },
      {
        id: 3,
        title: 'How to Score Up to 40% Off Premium Hotel Bookings',
        category: 'Travel Tips',
        image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&q=80&w=600',
        readTime: '4 min read'
      }
    ];

    return (
      <div className="blog-detail-page">
        
        {/* 1. Article Hero / Header */}
        <section className="detail-hero bg-dark-navy text-white py-5 position-relative">
          <div className="container py-4 position-relative z-2">
            <div className="row justify-content-center">
              <div className="col-lg-9 text-center">
                <a href="/blog" className="text-light opacity-75 text-decoration-none small d-inline-flex align-items-center mb-3 hover-text-white">
                  <i className="bi bi-arrow-left me-1"></i> Back to Journal
                </a>
                <div className="mb-3">
                  <span className="badge bg-primary-blue px-3 py-2 rounded-pill fw-bold text-uppercase tracking-wide">
                    {post.category}
                  </span>
                </div>
                <h1 className="display-5 fw-bold mb-4 line-height-md">{post.title}</h1>
                
                {/* Author Bar */}
                <div className="d-flex align-items-center justify-content-center gap-3 pt-2">
                  <img src={post.author.avatar} alt={post.author.name} className="rounded-circle detail-author-avatar" />
                  <div className="text-start">
                    <span className="fw-bold d-block text-white">{post.author.name}</span>
                    <span className="text-light opacity-75 small">{post.date} • {post.readTime}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Featured Main Image */}
        <div className="container position-relative z-3" style={{ marginTop: '-40px' }}>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <img src={post.heroImage} alt={post.title} className="w-100 rounded-4 shadow-lg detail-hero-img" />
            </div>
          </div>
        </div>

        {/* 2. Main Article Body & Sidebar */}
        <section className="py-5 bg-white">
          <div className="container py-4">
            <div className="row justify-content-center g-5">
              
              {/* Left Column: Article Content */}
              <div className="col-lg-8">
                
                <article className="article-body text-dark-navy fs-5 line-height-lg">
                  <p className="lead fs-4 text-secondary mb-4">
                    Bali remains an undisputed capital of tropical luxury, yet many travelers spend their vacations surrounded by bustling tourist hubs. If your ideal getaway involves infinity pools floating over untouched jungle canopies or private butler service on quiet cliffsides, this guide is for you.
                  </p>

                  <h3 className="fw-bold text-dark-navy mt-5 mb-3">1. The Royal Jungle Suite — Ubud Highlands</h3>
                  <p>
                    Nestled along the sacred Ayung River valley, this hidden 5-bedroom villa blends authentic Balinese teak architecture with modern minimalist interiors. Each bedroom opens directly onto a private deck overlooking lush coconut groves.
                  </p>
                  
                  {/* Inline Image with Caption */}
                  <div className="my-4">
                    <img 
                      src="https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&q=80&w=1200" 
                      alt="Ubud Villa Pool" 
                      className="w-100 rounded-4 shadow-sm mb-2"
                    />
                    <span className="text-muted small d-block text-center fst-italic">An infinity pool seamlessly merging with the Ubud forest canopy.</span>
                  </div>

                  <p>
                    Guest experiences here are centered around tranquility and holistic wellness. Included with every stay is a private chef specializing in farm-to-table Balinese cuisine, morning yoga sessions, and custom spa treatments in your open-air pavilion.
                  </p>

                  {/* Highlight Callout Box */}
                  <div className="tip-box my-4 p-4 rounded-4 bg-light-blue border-start-primary">
                    <div className="d-flex align-items-center gap-2 mb-2 text-primary-blue fw-bold">
                      <i className="bi bi-lightbulb-fill fs-4"></i>
                      <span>Bookly Insider Tip</span>
                    </div>
                    <p className="mb-0 text-dark-navy fs-6 line-height-md">
                      When booking through Bookly, request Villa No. 3 for the highest vantage point over the valley and complimentary floating breakfast service.
                    </p>
                  </div>

                  <h3 className="fw-bold text-dark-navy mt-5 mb-3">2. Cliffside Azure Sanctuary — Uluwatu</h3>
                  <p>
                    Perched 150 meters above the Indian Ocean, Uluwatu's Azure Sanctuary is engineered for sunset enthusiasts. Featuring floor-to-ceiling glass walls, sunken lounge pits, and direct private funicular access to Melasti Beach below.
                  </p>

                  <ul className="my-4 ps-4">
                    <li className="mb-2"><strong>Best for:</strong> Couples, honeymoons, and small intimate groups.</li>
                    <li className="mb-2"><strong>Key Feature:</strong> Heated saltwater infinity edge pool with ocean view.</li>
                    <li className="mb-2"><strong>Location:</strong> 10 minutes from Uluwatu Temple and top surfing spots.</li>
                  </ul>

                  {/* Pull Quote */}
                  <blockquote className="my-5 p-4 rounded-4 bg-light text-center border-start border-end border-primary-blue">
                    <p className="fst-italic fs-4 fw-medium text-dark-navy mb-2">
                      "True luxury lies not just in opulence, but in the effortless silence of a location untouched by routine."
                    </p>
                    <footer className="blockquote-footer text-primary-blue fw-bold mb-0">Sophia Reynolds</footer>
                  </blockquote>

                  <h3 className="fw-bold text-dark-navy mt-5 mb-3">3. Bamboo Eco Pavilion — Sidemen Valley</h3>
                  <p>
                    For travelers seeking sustainable living without compromising high-end comfort, Sidemen’s bamboo architectural masterpiece offers 360-degree views of Mount Agung and emerald rice terraces.
                  </p>
                </article>

                {/* 3. Social Share Buttons */}
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 py-4 my-5 border-top border-bottom">
                  <span className="fw-bold text-dark-navy">Share this article:</span>
                  <div className="d-flex gap-2">
                    <button className="btn btn-outline-secondary rounded-circle share-btn" title="Share on Facebook">
                      <i className="bi bi-facebook"></i>
                    </button>
                    <button className="btn btn-outline-secondary rounded-circle share-btn" title="Share on X">
                      <i className="bi bi-twitter-x"></i>
                    </button>
                    <button className="btn btn-outline-secondary rounded-circle share-btn" title="Share on LinkedIn">
                      <i className="bi bi-linkedin"></i>
                    </button>
                    <button className="btn btn-outline-secondary rounded-circle share-btn" title="Share on WhatsApp">
                      <i className="bi bi-whatsapp"></i>
                    </button>
                    <button className="btn btn-primary rounded-pill px-3 py-1 btn-sm fw-bold ms-2" onClick={this.handleCopyLink}>
                      <i className="bi bi-link-45deg me-1"></i> {copiedLink ? 'Copied!' : 'Copy Link'}
                    </button>
                  </div>
                </div>

                {/* 4. Author Bio Section */}
                <div className="author-card p-4 rounded-4 bg-light-gray border d-flex gap-4 align-items-center mb-5 flex-column flex-sm-row">
                  <img src={post.author.avatar} alt={post.author.name} className="rounded-circle author-card-avatar flex-shrink-0" />
                  <div>
                    <span className="badge bg-white text-primary-blue border fw-bold mb-1">Written By</span>
                    <h5 className="fw-bold text-dark-navy mb-1">{post.author.name}</h5>
                    <p className="text-muted small mb-2">{post.author.role}</p>
                    <p className="text-muted small mb-0 line-height-md">{post.author.bio}</p>
                  </div>
                </div>

                {/* 5. Comments Section UI */}
                <div className="comments-section pt-3">
                  <h4 className="fw-bold text-dark-navy mb-4">Discussion ({comments.length})</h4>

                  {/* Comment Form */}
                  <div className="comment-form-wrapper p-4 rounded-4 bg-light border mb-5">
                    <h5 className="fw-bold text-dark-navy mb-3">Leave a Reply</h5>
                    
                    {isCommentSubmitted && (
                      <div className="alert alert-success rounded-3 p-3 small mb-3">
                        <i className="bi bi-check-circle me-1"></i> Thank you! Your comment has been posted.
                      </div>
                    )}

                    <form onSubmit={this.handleCommentSubmit}>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Your Name *" 
                            value={commentName}
                            onChange={(e) => this.setState({ commentName: e.target.value })}
                            required
                          />
                        </div>
                        <div className="col-md-6">
                          <input 
                            type="email" 
                            className="form-control" 
                            placeholder="Your Email Address *" 
                            value={commentEmail}
                            onChange={(e) => this.setState({ commentEmail: e.target.value })}
                            required
                          />
                        </div>
                        <div className="col-12">
                          <textarea 
                            className="form-control" 
                            rows="4" 
                            placeholder="Share your thoughts or ask a question..." 
                            value={commentMessage}
                            onChange={(e) => this.setState({ commentMessage: e.target.value })}
                            required
                          ></textarea>
                        </div>
                        <div className="col-12">
                          <button type="submit" className="btn btn-primary rounded-pill px-4 fw-bold">
                            Post Comment
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                  {/* Existing Comments List */}
                  <div className="comments-list d-flex flex-column gap-3">
                    {comments.map((comment) => (
                      <div key={comment.id} className="comment-item p-4 rounded-4 bg-white border">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <div className="d-flex align-items-center gap-3">
                            <img src={comment.avatar} alt={comment.name} className="rounded-circle author-avatar-sm" />
                            <div>
                              <h6 className="fw-bold text-dark-navy mb-0">{comment.name}</h6>
                              <span className="text-muted small">{comment.date}</span>
                            </div>
                          </div>
                          <button className="btn btn-link text-primary-blue text-decoration-none small fw-bold p-0">
                            Reply
                          </button>
                        </div>
                        <p className="text-muted small mb-0 ps-5 line-height-md">{comment.text}</p>
                      </div>
                    ))}
                  </div>

                </div>

              </div>

              {/* Right Column: Sticky Sidebar */}
              <div className="col-lg-4">
                <div className="detail-sidebar sticky-top" style={{ top: '100px' }}>
                  
                  {/* Book Stay Card Widget */}
                  <div className="p-4 bg-dark-navy text-white rounded-4 shadow-sm mb-4 position-relative overflow-hidden">
                    <span className="badge bg-warning text-dark-navy fw-bold mb-2">Bookly Special</span>
                    <h4 className="fw-bold mb-2">Planning a Bali Trip?</h4>
                    <p className="small text-light opacity-80 mb-4">Explore our luxury villa collection with instant confirmation & free cancellation options.</p>
                    <a href="/search" className="btn btn-primary w-100 rounded-pill py-2 fw-bold">
                      Find Stays in Bali
                    </a>
                  </div>

                  {/* Related Articles Widget */}
                  <div className="p-4 bg-white rounded-4 border shadow-sm mb-4">
                    <h5 className="fw-bold text-dark-navy mb-3">Related Reads</h5>
                    <div className="d-flex flex-column gap-3">
                      {relatedPosts.map((item) => (
                        <a key={item.id} href="/blog/details" className="d-flex gap-3 text-decoration-none hover-text-blue">
                          <img src={item.image} alt={item.title} className="rounded-3 related-thumb object-fit-cover" />
                          <div>
                            <span className="badge bg-light text-muted small mb-1">{item.category}</span>
                            <h6 className="fw-bold text-dark-navy small line-clamp-2 mb-0">{item.title}</h6>
                          </div>
                        </a>
                      ))}
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

        {/* 6. Call To Action Section */}
        <section className="detail-cta py-5 text-white position-relative">
          <div className="container py-4 text-center position-relative z-2">
            <h2 className="display-6 fw-bold mb-3">Ready to Turn Your Travel Dreams Into Reality?</h2>
            <p className="lead opacity-90 mx-auto mb-4" style={{ maxWidth: '650px' }}>
              Book your next stay with Bookly and unlock exclusive member discounts on over 15,000 verified accommodations worldwide.
            </p>
            <a href="/search" className="btn btn-warning btn-lg rounded-pill px-5 py-3 fw-bold text-dark-navy hover-scale">
              Book Your Next Stay
            </a>
          </div>
          <div className="cta-overlay"></div>
        </section>

      </div>
    );
  }
}

export default BlogDetail;